import styled, { css } from 'styled-components';

export const GateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 16px;

  ${({ theme }) => css`
    background-color: ${theme.colors?.background || '#0D0D16'};
  `}
`;

export const GateCard = styled.div`
  width: 100%;
  max-width: 400px;
  border-radius: 16px;
  text-align: center;

  ${({ theme }) => css`
    background-color: ${theme.colors?.surfaceContainer || '#1E1E32'};
    border: 1px solid ${theme.colors?.outlineVariant || '#333'};
    padding: ${theme.spacing?.level7 || '32px'};
  `}
`;

export const GateTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px 0;

  ${({ theme }) => css`
    color: ${theme.colors?.onSurface || '#ffffff'};
    font-family: ${theme.font?.fontFamily || "'Inter Variable', 'Inter', sans-serif"};
  `}
`;

export const GateSubtitle = styled.p`
  font-size: 14px;
  margin: 0 0 24px 0;

  ${({ theme }) => css`
    color: ${theme.colors?.onSurfaceVariant || '#aaa'};
  `}
`;

export const PasswordInput = styled.input`
  width: 100%;
  border: none;
  outline: none;
  font-size: 14px;
  box-sizing: border-box;

  ${({ theme }) => css`
    padding: ${theme.spacing?.level3 || '12px'} ${theme.spacing?.level4 || '16px'};
    background-color: ${theme.colors?.surfaceContainerHigh || '#252540'};
    color: ${theme.colors?.onSurface || '#fff'};
    border-radius: ${theme.borderRadius?.medium || '8px'};
    font-family: ${theme.font?.fontFamily || "'Inter Variable', 'Inter', sans-serif"};

    &::placeholder {
      color: ${theme.colors?.onSurfaceVariant || '#888'};
    }

    &:focus {
      box-shadow: 0 0 0 2px ${theme.colors?.primary || '#C1C1FF'}40;
    }
  `}
`;

export const SubmitButton = styled.button`
  width: 100%;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  margin-top: 16px;
  border-radius: 8px;
  transition: opacity 0.15s ease;

  ${({ theme }) => css`
    padding: ${theme.spacing?.level3 || '12px'};
    background-color: ${theme.colors?.primary || '#C1C1FF'};
    color: ${theme.colors?.onPrimary || '#1A1A2E'};
    font-family: ${theme.font?.fontFamily || "'Inter Variable', 'Inter', sans-serif"};
  `}

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ErrorText = styled.p`
  font-size: 13px;
  margin: 12px 0 0 0;

  ${({ theme }) => css`
    color: ${theme.colors?.error || '#EF5350'};
  `}
`;
